module.exports = __webpack_public_path__ + "img/1_012.21217a83.jpg";